export default __webpack_public_path__ + "static/media/rectangel2.dcc5e6b5.svg";